import { Component, inject, TemplateRef, ViewChild, signal } from '@angular/core';
import { TabComponent } from '../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';
import { ButtonDirective } from '../../../components/button/button.directive';
import { NgIcon } from '@ng-icons/core';
import { RowAction, TableRow } from '../../../components/table/table.interface';
import { PendingLeavesService } from '../../../pending-leaves.service';
import { LoadingSpinnerComponent } from '../../../components/loading-spinner/loading-spinner.component';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-pending-leaves',
  imports: [TabLayoutComponent, APITableComponent, ButtonDirective, NgIcon, LoadingSpinnerComponent],
  providers: [{ provide: TabComponent, useExisting: PendingLeavesComponent }],
  templateUrl: './pending-leaves.component.html',
  styleUrl: './pending-leaves.component.scss',
})
export class PendingLeavesComponent extends TabComponent {
  override name: string = this.dictionaryService.get('PendingLeaves');
  public async main(): Promise<void> { }
  pendingLeavesServices = inject(PendingLeavesService)

  @ViewChild('acceptLeaveButton', { static: true }) acceptLeaveButton!: TemplateRef<any>;
  @ViewChild('rejectLeaveButton', { static: true }) rejectLeaveButton!: TemplateRef<any>;
  @ViewChild(APITableComponent) childTable!: APITableComponent;

  actionCols: RowAction[] = []

  confirmingLeave = signal<{ row: string, accept: boolean } | null>(null)
  ngOnInit() {
    this.actionCols = [
      {
        actionButton: this.acceptLeaveButton,
        onClick: (row: TableRow) => this.confirmLeave(row, true),
        headerName: 'Accept',
      },
      {
        actionButton: this.rejectLeaveButton,
        onClick: (row: TableRow) => this.confirmLeave(row, false),
        headerName: 'Reject',
      },
    ];
  }

  confirmLeave = (row: TableRow, accept = true) => {
    this.confirmingLeave.set({ row: row.id, accept })
    this.pendingLeavesServices.confirmPendingLeaves(row.value["Id"] as string, accept).subscribe({
      next: () => {
        if (this.childTable) {
          this.confirmingLeave.set(null)
          this.childTable.refresh()
        }
      }
    })
  }

}
